import { Skeleton, SkeletonProps } from '@ghq-abi/design-system';

export { AccessCardSkeleton } from './AccessCardSkeleton';
export { CardGridSkeleton } from './CardGridSkeleton';
export {
  CARD_SKELETON_HEIGHT,
  PROGRESS_CARD_WIDTH,
  REQUEST_CARD_WIDTH,
  SKELETON_CARD_COUNT
} from './constants';
export { ProgressCardSkeleton } from './ProgressCardSkeleton';
export { RequestCardSkeleton } from './RequestCardSkeleton';

interface SkeletonsProp extends SkeletonProps {
  quantity?: number;
}

export function Skeletons({
  quantity = 1,
  height,
  width = '$full',
  ...rest
}: SkeletonsProp) {
  return (
    <>
      {Array.from({ length: quantity }, (_, i) => i).map(i => (
        <Skeleton
          key={i}
          variant="rectangle"
          css={{ width, minHeight: height, m: 0 }}
          {...rest}
        />
      ))}
    </>
  );
}
